export default __webpack_public_path__ + "static/media/ems-logo.61a85d6d.png";